import { formatCredits } from '@/@credit-consumption/utils/formatCredits';

/**
 * Assistant reply and banner copy when a Studio user's own monthly limit is reached. Only MFour
 * staff have per-person limits (D26), so the next step is a credits admin, never the client's team.
 */
export function userSpendLimitChatText(used?: number, limit?: number): string {
    const reached =
        typeof used === 'number' && typeof limit === 'number'
            ? `You've used ${formatCredits(used)} of your ${formatCredits(limit)} monthly AI credit limit.`
            : "You've reached your monthly AI credit limit.";
    return `${reached} DANI chats are paused. Ask a credits admin to raise it.`;
}

/** The input keeps the caller's pause text unless the organization trial cap itself is spent. */
export function chatInputEffectivePlaceholder(input: {
    placeholder: string;
    orgUsageLimitReached: boolean;
    compact: boolean;
    usageUnit: 'queries' | 'tokens';
}): string {
    if (!input.orgUsageLimitReached) return input.placeholder;
    return input.compact
        ? `Organization ${input.usageUnit} limit reached`
        : `Organization ${input.usageUnit} limit reached — contact your administrator to raise the limit.`;
}

export function creditPausePlaceholder(reason: string | null | undefined): string {
    if (reason === 'annual_pool_exceeded') {
        return 'DANI is paused — annual credit pool exhausted';
    }
    if (reason === 'user_spend_limit_exceeded') {
        return 'DANI is paused — your monthly credit limit is reached';
    }
    if (reason === 'license_expired') {
        return 'DANI is paused — Studio AI license ended';
    }
    if (reason === 'no_credits') {
        return 'DANI is paused — no Studio AI credits available';
    }
    return 'DANI is paused — monthly compute cap reached';
}
